// Components
import { BaseImage, BaseLabel } from 'components';

// Antd
import { Modal, Button } from 'antd';

// i18n
import { useTranslation } from 'react-i18next';

// Interfaces
import { IBaseDialogVerification } from './interfaces';

// Styles
import './styles.scss';

const BaseDialogVerification = ({
  isOpen,
  header,
  body,
  onFirstButtonClick,
  onSecondButtonClick,
  onButtonCloseClick,
  onAfterClose,
  firstButtonLabel,
  secondButtonLabel,
  isUsingSecondButton,
  isFirstButtonLoading,
  isSecondButtonLoading,
  closable,
  isHorizontalFooter,
  footer,
  isUsingDefaultFooter,
}: IBaseDialogVerification) => {
  // Hook
  const { t } = useTranslation();

  return (
    <Modal visible={isOpen} centered footer={null} closable={false} afterClose={onAfterClose}>
      <div className="base-dialog-verification">
        {closable && (
          <div
            style={{ position: 'absolute', top: 10, right: 15, cursor: 'pointer', zIndex: 1000000 }}
            onClick={onButtonCloseClick}
          >
            <BaseImage isIcon isSvg icon="icon-close" />
          </div>
        )}

        {/* Header */}
        {header ? header : <BaseLabel label={t('app._alert')} className="font-14 font-weight-700 mb-4" isBold />}

        {/* Body */}
        {body && <div className="body">{body}</div>}

        {/* Footer */}
        <div className={`footer ${isHorizontalFooter ? 'horizontal' : ''}`}>
          {/* Check if user want to use default footer */}
          {isUsingDefaultFooter && (
            <>
              <Button type="primary" className="custom-button" onClick={onFirstButtonClick} loading={isFirstButtonLoading}>
                {firstButtonLabel && t(firstButtonLabel)}
              </Button>

              {isUsingSecondButton && (
                <Button type="text" className="custom-button" onClick={onSecondButtonClick} loading={isSecondButtonLoading}>
                  {secondButtonLabel && t(secondButtonLabel)}
                </Button>
              )}
            </>
          )}

          {/* Otherwise, user will use new footer or both */}
          {footer ? footer : <></>}
        </div>
      </div>
    </Modal>
  );
};

BaseDialogVerification.defaultProps = {
  isUsingDefaultFooter: true,
};

export { BaseDialogVerification };
